import React from "react";
import Header from "../../Components/Header/Header";
import ContactItems from "./ContactItems/ContactItems";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";

const Contact = () => {
  const { t } = useTranslation();

  return ( 
    <>
      <Breadcrumb title={t("Əlaqə")} />
      <ContactItems />
    </>
  );
};

export default Contact;
